export enum HttpStatusCode {
  Ok = 200,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  RequestTimeout = 408,
  UnsupportedMediaType = 415,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504
}

// Mảng chứa mã lỗi và tên lỗi
export const httpErrCodeArray = [
  // 4xx: Client Errors
  { code: HttpStatusCode.BadRequest, name: '400 - Bad Request' },
  { code: HttpStatusCode.Unauthorized, name: '401 - Unauthorized' },
  { code: HttpStatusCode.Forbidden, name: '403 - Forbidden' },
  { code: HttpStatusCode.NotFound, name: '404 - Not Found' },
  { code: HttpStatusCode.MethodNotAllowed, name: '405 - Method Not Allowed' },
  { code: HttpStatusCode.RequestTimeout, name: '408 - Request Timeout' },
  {
    code: HttpStatusCode.UnsupportedMediaType,
    name: '415 - Unsupported Media Type'
  },

  // 5xx: Server Errors
  {
    code: HttpStatusCode.InternalServerError,
    name: '500 - Internal Server Error'
  },
  { code: HttpStatusCode.NotImplemented, name: '501 - Not Implemented' },
  { code: HttpStatusCode.BadGateway, name: '502 - Bad Gateway' },
  {
    code: HttpStatusCode.ServiceUnavailable,
    name: '503 - Service Unavailable'
  },
  { code: HttpStatusCode.GatewayTimeout, name: '504 - Gateway Timeout' }
];

// Interface cho type safety
export interface HttpStatusCodeItem {
  code: number;
  name: string;
}

// Helper functions
export const getHttpStatusCodeName = (code: number): string => {
  const item = httpErrCodeArray.find((item) => item.code === code);
  return item ? item.name : 'Unknown Status Code';
};
